import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable} from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { EntityFileSearchModel } from 'src/app/core/models/file/entity-file-search-model';
import { EntityFileModel } from 'src/app/core/models/file/entity-file-model';
import { GlobalComponent } from 'src/app/global-component';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { SearchResultModel } from 'src/app/core/models/query/search-result-model';
import { BaseListService } from './base-list.service';
import { EntityFileUploadModel } from '../../models/file/entity-file-upload-model';

@Injectable({ providedIn: 'root' })
export class FileManagementService extends BaseListService {

  defaultEntityFileSearchListState: EntityFileSearchModel = {
    sortColumnDirective: '',
    sortDirectionDirective: '',
    pageSize: GlobalComponent.defaultPagingInfo.pageSize,
    getFileList: new EntityFileUploadModel(),
    startIndex: 0,
    searchTerm: undefined,
    pageIndex: 0,
    sortColumn: undefined,
    sortDirection: undefined
  };

  private _resultItems$ = new BehaviorSubject<EntityFileModel[]>([]);
  protected override _state: EntityFileSearchModel = { ...this.defaultEntityFileSearchListState };

  constructor(
    private myFileApiService: MyfileApiService) {
    super();
    this._search$.pipe(
      tap(() => this._loading$.next(true)),
      switchMap(() => this._search()),
      tap(() => this._loading$.next(false))
    ).subscribe((result: any) => {
      if(result !== undefined){
        this._resultItems$.next(result.items);
        this._total$.next(result.count);
      }
    });
  }

  get resultItems$() { return this._resultItems$.asObservable(); }

  set getFileList(entityFileUploadModel: EntityFileUploadModel) { this._state.getFileList = entityFileUploadModel; }

  protected _search(): Observable<SearchResultModel<EntityFileModel> | undefined> {

    this.validateStartIndex();

    this._state.sortColumn = this.titleCaseWord(this._state.sortColumnDirective) as string;

    return this.myFileApiService.getPageableFileList(this._state);
  }

  override clearListService(): void {
    this._state = { ...this.defaultEntityFileSearchListState };
    this._resultItems$.next(new Array<EntityFileModel>());
    this._total$.next(0);
  }

}